'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.beacon = beacon;
exports.pixel = pixel;

var _navigator = require('./navigator');

function beacon(url) {
  return new Promise(function (resolve, reject) {
    return (0, _navigator.sendBeacon)(url) ? resolve(url) : reject(url);
  });
}

function pixel(url, image) {
  return new Promise(function (resolve, reject) {
    var biImage = image || new Image(0, 0);
    biImage.onload = resolve;
    biImage.onerror = reject;
    biImage.src = url;
  });
}
//# sourceMappingURL=transport.js.map



//////////////////
// WEBPACK FOOTER
// ./~/web-bi-logger/dist/src/lib/transport.js
// module id = 1125
// module chunks = 15 16 17 18 19